<template>
  <div v-show="appliedDiscounts.length>0">
    <div class="discount-summary">
      <!--              <h3 class="discount-summary__title">Rabatt-Details</h3>-->

      <div class="discount-summary__table">
        <div class="discount-summary__head">
          <div class="discount-summary__header-cell left">Artikel</div>
          <div class="discount-summary__header-cell left">Rabatt</div>
          <div class="discount-summary__header-cell discount-summary__header-cell">%</div>
          <div class="discount-summary__header-cell right">Ersparnis</div>
        </div>

        <div class="discount-summary__body">
          <div
            v-for="(entry, index) in appliedDiscounts"
            :key="index"
            class="discount-summary__row"
          >
            <div class="discount-summary__cell left">{{ entry.itemName }}</div>
            <div class="discount-summary__cell left">{{ entry.discountName }}</div>
            <div class="discount-summary__cell">
              {{ entry.percentage }}%
            </div>
            <div class="discount-summary__cell right discount-summary__cell--highlight">
              -{{ entry.absoluteAmount.toFixed(2) }}€
            </div>
          </div>
        </div>

        <!--                <div class="discount-summary__footer">-->
        <!--                  <div class="discount-summary__footer-label">Gesamte Ersparnis:</div>-->
        <!--                  <div class="discount-summary__footer-value">-->
        <!--                    -{{ totalSavedByDiscounts.toFixed(2) }}€-->
        <!--                  </div>-->
        <!--                </div>-->

      </div>

      <div v-if="appliedDiscounts.length === 0" class="discount-summary__empty">
        Keine Rabatte angewendet.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscountsSummary",
  props: {
    appliedDiscounts: Array,
  },
}
</script>

<style scoped lang="scss">
@import '../discounts/discountSummry';

</style>
